import type { Edge } from '@xyflow/react';

import type { OrgMvpNode } from './organogramaTypes';

export const HISTORY_LIMIT = 60;

export type OrgMvpHistorySnapshot = {
  nodes: OrgMvpNode[];
  edges: Edge[];
  selectedNodeId: string | null;
};

export const cloneNodesForHistory = (nodes: OrgMvpNode[]): OrgMvpNode[] =>
  nodes.map((node) => ({
    ...node,
    position: { ...node.position },
    data: { ...node.data },
    style: node.style ? { ...node.style } : undefined,
  }));

export const cloneEdgesForHistory = (edges: Edge[]): Edge[] =>
  edges.map((edge) => ({
    ...edge,
    data: edge.data ? { ...edge.data } : undefined,
    style: edge.style ? { ...edge.style } : undefined,
  }));

export const makeHistorySnapshot = (
  nodes: OrgMvpNode[],
  edges: Edge[],
  selectedNodeId: string | null,
): OrgMvpHistorySnapshot => ({
  nodes: cloneNodesForHistory(nodes),
  edges: cloneEdgesForHistory(edges),
  selectedNodeId,
});

export const historySnapshotsEqual = (a: OrgMvpHistorySnapshot, b: OrgMvpHistorySnapshot) =>
  JSON.stringify(a) === JSON.stringify(b);
